import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import "./dashboard.css";
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { getallmembershiptypes } from '../store/slices/userSlice';
import PaginatedTable from '../services/paginatedtable';
import Swal from "sweetalert2";
import { getallmembershippaymentsbymember } from '../store/slices/userSlice';

function Membershippaymentsbyid() {
  const [searchParams] = useSearchParams();
  const [id, setId] = useState(null);
  const [total, setTotal] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);  // Initialize as empty array, not true
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // <-- Added this line

  const [selected, setSelected] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {

      var id=localStorage.getItem('id')
      const response = await getallmembershippaymentsbymember(id);
      setData(Array.isArray(response?.data) ? response.data : []);
    } catch (err) {
      Swal.fire('Error', 'Error getting data.', 'error');
      setError('Error getting data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchDataSafely = async () => {
      try {
        await fetchData();
      } catch (error) {
        console.error("Error fetching data:", error);
        // Optional: show alert or notification
        // Swal.fire("Error", "Failed to fetch data", "error");
      }
    };
  
    fetchDataSafely();
  }, []);
  

  

  return (
    <div>
      <Navbar />
      <Sidebar />
      {loading && (
        <div className="preloader">
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="folio-container"></div>
              <div className="row">
                <div className="col-lg-12 d-flex align-items-stretch">
                  <div className="card w-100">
                    <div className="card-body">
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                        <h4 className="card-title fw-semibold">My Payments</h4>

                        
                      
                      </div>
                      <div className="col-lg-12">
                        {loading ? (
                          <p>Loading...</p>
                        ) : error ? (
                          <p className="text-danger">Error: {error}</p>
                        ) : data.length > 0 ? (
                          <div className="table-responsive">
                            <PaginatedTable
                              columns={[
                                "date",
                                "member_name",
                                "membership_type",
                                "amount",
                                "paymentmode",
                                "transactionid",
                                "chequenumber",
                                "bank",
                                "chequedate",
                                "status",
                              ]}
                              data={data}
                              showedit={false}
                              showdownload={false}
                              
                            />
                          </div>
                        ) : (
                          <p>No data available</p>
                        )}
                      </div>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Membershippaymentsbyid;
